export const localStorageEffect = key => ({setSelf, onSet}) => {
    const savedValue = localStorage.getItem(key)
    if (savedValue != null) {
        try {
            let jsonValue = JSON.parse(savedValue);
            setSelf(jsonValue);
        } catch (e) {
            localStorage.removeItem(key);
        }
    }

    onSet(newValue => {
        if (newValue instanceof Boolean) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, JSON.stringify(newValue));
        }
    });
};